import { ReactNode } from "react";
import "./CardHeader.scss";

export interface CardHeaderProps {
  /**
   * The title of the card header.
   */
  title: string;
  /**
   * The supporting text of the card header.
   */
  supportingText?: string;
  /**
   * The badge of the card header.
   */
  badge?: ReactNode;
  /**
   * The actions of the card header.
   */
  actions?: ReactNode;
  /**
   * Show border
   */
  showBorder?: boolean;
  /**
   * Additional class name
   */
  className?: string;
}

const CardHeader = function (props: CardHeaderProps) {
  const { title, supportingText, badge, actions, showBorder = true, className } = props;
  return (
    <div className={`v2-card-header ${showBorder && "border-bottom-secondary"} ${className}`}>
      <div className="flex-initial">
        <div className="d-flex gap-md align-items-center">
          <p className="text-lg font-medium">{title}</p>
          {badge && <>{badge}</>}
        </div>
        {supportingText && <p className="text-sm text-tertiary font-regular">{supportingText}</p>}
      </div>
      {actions && <div>{actions}</div>}
    </div>
  );
};
CardHeader.defaultProps = {
  supportingText: undefined,
  badge: undefined,
  actions: undefined,
  showBorder: false,
  className: "",
};
export default CardHeader;
